import { createStore } from "../../../utils/createStore.ts";

export const scrollToEditionHistoryStore = createStore(
  {
    scrollTrigger: 0,
  },
  ({ set }) => ({
    triggerScrollToEditionHistory: () =>
      // XXX: We use Date.now() to trigger a re-render of the other components, each time we call this function.
      set({
        scrollTrigger: Date.now(),
      }),
  }),
);
